<template>
  <div class="contractPreview">
    <hl-ContractPreview :contract-id="id" />
  </div>
</template>

<script>
import Vue from 'vue';
import ContractPreviewComponent from '@modules/husleie-framework/src/components/ContractPreview.vue';

export default Vue.extend({
  name: 'ContractPreview',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    'hl-ContractPreview': ContractPreviewComponent,
  },
});
</script>

<style lang="scss" scoped>
@media (min-width: 1200px) {
  .contractPreview {
    margin-top: 2rem;
    padding: 0 6rem 2rem 6rem;
  }
}
</style>
